import React, { useEffect, useState } from "react";
import Header from "./Header";
import CustomModal from "../CustomModal";
import { useNavigate } from "react-router-dom/dist";
import bannerimage from "../Assets/banner.jpg";
import PhoneInput from "react-phone-input-2";
import "react-phone-input-2/lib/style.css";
import Footer from "./Footer";
import axios from "axios";
import DupModal from "../DupModal";
import { ToastContainer, toast } from "react-toastify";

const Optin = () => {
  const navigate = useNavigate();

  useEffect(() => {
    window.scroll(0, 0);
  }, []);

  const [formData, setFormData] = useState({
    first_name: "",
    last_name: "",
    mobile_number: "",
    email_id: "",
    occupation: "",
    qualification: "",
    dob: "",
    gender: "",
    state: "",
    district: "",
    opted_for: []
  });

  const [errors, setErrors] = useState({});
  const [isSubmitting, setIsSubmitting] = useState(false);

  const showToastSuccessMsg = (successMsg) => {
    toast.success(successMsg, {
      position: toast.POSITION.TOP_RIGHT,
      className: "toast-message",
      autoClose: 5000,
    });
  };

  const showToastErrorMsg = (errMsg) => {
    toast.error(errMsg, {
      position: toast.POSITION.TOP_RIGHT,
      className: "toast-message",
      autoClose: false,
    });
  };

  const validateForm = () => {
    const newErrors = {};
    if (!formData.first_name) newErrors.first_name = "First Name is required";
    if (!formData.last_name) newErrors.last_name = "Last Name is required";
    if (!formData.mobile_number) newErrors.mobile_number = "Mobile number is required";
    if (!formData.email_id) newErrors.email_id = "Email is required";
    if (!formData.occupation) newErrors.occupation = "Occupation is required";
    if (!formData.qualification) newErrors.qualification = "Qualification is required";
    if (!formData.dob) newErrors.dob = "DOB is required";
    else {
      // Parse the date of birth
      const dob = new Date(formData.dob);
      const today = new Date();

      // Calculate the age
      const age = today.getFullYear() - dob.getFullYear();
      const month = today.getMonth() - dob.getMonth();

      // If the person is younger than 18
      if (age < 18 || (age === 18 && month < 0)) {
        newErrors.dob = "You must be at least 18 years old";
      }
    }
    if (!formData.gender) newErrors.gender = "Gender is required";
    if (!formData.state) newErrors.state = "State is required";
    if (!formData.district) newErrors.district = "District is required";
    if (!formData.opted_for.length) newErrors.opted_for = "Opted for is required";
    setErrors(newErrors);
    return Object.keys(newErrors).length === 0;
  };
  const handleChange = (e) => {
    const { name, options } = e.target;
    if (name === 'opted_for') {
      const selectedOptions = Array.from(options)
        .filter(option => option.selected)
        .map(option => option.value);

      setFormData({
        ...formData,
        [name]: selectedOptions,
      });
    } else {
      setFormData({
        ...formData,
        [e.target.name]: e.target.value,
      });
    }

  };
  const handleSubmit = async (e) => {
    e.preventDefault();
    if (!validateForm()) return;

    setIsSubmitting(true);

    const response = await freelauncerSubmit(JSON.stringify(formData));
    if (response && response.statusCode === 200) {
      showToastSuccessMsg(response.message);
      setFormData({
        first_name: "",
        last_name: "",
        mobile_number: "",
        email_id: "",
        occupation: "",
        qualification: "",
        dob: "",
        gender: "",
        state: "",
        district: "",
        opted_for: []
      });
    } else {
      showToastErrorMsg(
        response.message || response.error.response.data.message
      );
    }

    setIsSubmitting(false);
  };
  const getIndianStates = () => [
    "Andhra Pradesh",
    "Telangana",
    "Keralam",
    "Tamil Nadu",
    "Karnataka"
  ];
  const getDistricts = (state) => {
    switch (state) {
      case "Andhra Pradesh":
        return [
          "Srikakulam",
          "Parvathipuram Manyam",
          "Vizianagaram",
          "Visakhapatnam",
          "Alluri Sitharama Raju",
          "Anakapalli",
          "Kakinada",
          "East Godavari",
          "Konaseema",
          "Eluru",
          "West Godavari",
          "NTR",
          "Krishna",
          "Palnadu",
          "Guntur",
          "Bapatla",
          "Sri Potti Sriramulu Nellore",
          "Prakasam",
          "Kurnool",
          "Nandyal",
          "Anantapuramu",
          "Sri Sathya Sai",
          "YSR",
          "Annamayya",
          "Tirupati",
          "Chittoor"
        ];
      case "Telangana":
        return [
          "Adilabad",
          "Kumuram Bheem Asifabad",
          "Mancherial",
          "Nirmal",
          "Nizamabad",
          "Jagtial",
          "Peddapalli",
          "Kamareddy",
          "Rajanna Sircilla",
          "Karimnagar",
          "Jayashankar Bhupalpally",
          "Sangareddy",
          "Medak",
          "Siddipet",
          "Jangaon",
          "Hanumakonda",
          "Warangal",
          "Mulugu",
          "Bhadradri Kothagudem",
          "Khammam",
          "Mahabubabad",
          "Suryapet",
          "Nalgonda",
          "Yadadri Bhuvanagiri",
          "Medchal–Malkajgiri",
          "Hyderabad",
          "Ranga Reddy",
          "Vikarabad",
          "Narayanpet",
          "Mahabubnagar",
          "Nagarkurnool",
          "Wanaparthy",
          "Jogulamba Gadwal"
        ];
      case "Keralam":
        return [
          "Alappuzha",
          "Ernakulam",
          "Idukki",
          "Kannur",
          "Kasaragod",
          "Kollam",
          "Kottayam",
          "Kozhikode",
          "Malappuram",
          "Palakkad",
          "Pathanamthitta",
          "Thiruvananthapuram",
          "Thrissur",
          "Wayanad"
        ];
      case "Tamil Nadu":
        return [
          "Ariyalur",
          "Chengalpattu",
          "Chennai",
          "Coimbatore",
          "Cuddalore",
          "Dharmapuri",
          "Dindigul",
          "Erode",
          "Kallakurichi",
          "Kancheepuram",
          "Kanyakumari",
          "Karur",
          "Krishnagiri",
          "Madurai",
          "Mayiladuthurai",
          "Nagapattinam",
          "Namakkal",
          "Nilgiris",
          "Perambalur",
          "Pudukkottai",
          "Ramanathapuram",
          "Ranipet",
          "Salem",
          "Sivaganga",
          "Tenkasi",
          "Thanjavur",
          "Theni",
          "Thoothukudi",
          "Tiruchirappalli",
          "Tirunelveli",
          "Tirupathur",
          "Tiruppur",
          "Tiruvallur",
          "Tiruvannamalai",
          "Tiruvarur",
          "Vellore",
          "Viluppuram",
          "Virudhunagar"
        ];
      case "Karnataka":
        return [
          "Bagalkote",
          "Bengaluru Urban",
          "Bengaluru Rural",
          "Belagavi",
          "Ballari",
          "Bidar",
          "Vijayapura",
          "Chamarajanagar",
          "Chikkaballapura",
          "Chikkamagaluru",
          "Chitradurga",
          "Dakshina Kannada",
          "Davanagere",
          "Dharwad",
          "Gadag",
          "Kalaburagi",
          "Hassan",
          "Haveri",
          "Kodagu",
          "Kolar",
          "Koppal",
          "Mandya",
          "Mysuru",
          "Raichur",
          "Ramanagara",
          "Shivamogga",
          "Tumakuru",
          "Udupi",
          "Uttara Kannada",
          "Vijayanagara",
          "Yadgiri"
        ];
      default:
        return [];
    }
  };

  const freelauncerSubmit = async (Payload) => {
    const response = await axios
      .post(`https://dalmaf.com/entrepreneur-service/v1/entrepreneur/create`, Payload, {
        headers: {
          Accept: "application/json",
          "Content-Type": "application/json",
        },
      })
      .then((response) => {
        return response.data;
      })
      .catch((error) => ({ error: error }));
    return response;
  };

  return (
    <>
      <ToastContainer />
      <Header />
      <section style={{ padding: "20px 0" }}>
        <div className="">
          <h3 class="title">
            Start Your <span class="parahighlight">Entrepreneur</span> Journey with Us&nbsp;
            <br />Earn <span class="parahighlight">30K – 50K</span> INR per month
          </h3>
        </div>
      </section>
      <section>
        <div class="container py-5">
          <div class="row">
            <div class="col-lg-6">
              <p class="para">Start your<span class="parahighlight"> Entrepreneur </span>Journey with us and get Benefits</p>
              <p class="subpara">
                <span class="icon">✔</span> Monthly we provide 100 to 200 business leads<br />
                <span class="icon">✔</span> Our Legal, Audit and H.R team will help you to get business<br />
                <span class="icon">✔</span> No Limitation or Contract Period<br />
                <span class="icon">✔</span> Easily you can Do business<br />
                <span class="icon">✔</span> You will gain expertise in overseeing corportate organization<br />
                <span class="icon">✔</span> You can earn monthly 30,000 to 50,000 per month<br />
              </p>
            </div>
            <div class="col-lg-6">
              {/* <img src={bannerimage} alt="Dalmaf Entrepreneur" class="bannerimage"/> */}
              <div className="card form-container-r">
                <div className="card-header">
                  <h2 className="section-title text-center">Join Us</h2>
                </div>
                <div className="card-body">
                  <form onSubmit={handleSubmit}>
                    {/* First Name & Last Name */}
                    <div className="row">
                      <div className="col-md-6 col-sm-12 mb-3">
                        <div className="form-floating">
                          <input
                            type="text"
                            className="form-control"
                            placeholder="First Name"
                            name="first_name"
                            value={formData.first_name}
                            onChange={handleChange}
                          />
                          <label htmlFor="first_name">First Name</label>
                        </div>
                        {errors.first_name && <small className="text-danger">{errors.first_name}</small>}
                      </div>
                      <div className="col-md-6 col-sm-12 mb-3">
                        <div className="form-floating">
                          <input
                            type="text"
                            className="form-control"
                            placeholder="Last Name"
                            name="last_name"
                            value={formData.last_name}
                            onChange={handleChange}
                          />
                          <label htmlFor="last_name">Last Name</label>
                        </div>
                        {errors.last_name && <small className="text-danger">{errors.last_name}</small>}
                      </div>
                    </div>
                    {/* Mobile Number & Email id */}
                    <div className="row">
                      <div className="col-md-6 col-sm-12 mb-3">
                        <div className="form-floating">
                          <input
                            type="text"
                            className="form-control"
                            placeholder="Mobile Number"
                            name="mobile_number"
                            value={formData.mobile_number}
                            onChange={handleChange}
                          />
                          <label htmlFor="mobile_number">Mobile Number</label>
                          {errors.mobile_number && <small className="text-danger">{errors.mobile_number}</small>}
                        </div>
                      </div>
                      <div className="col-md-6 col-sm-12 mb-3">
                        <div className="form-floating">
                          <input
                            type="email"
                            className="form-control"
                            placeholder="Email Id"
                            name="email_id"
                            value={formData.email_id}
                            onChange={handleChange}
                          />
                          <label htmlFor="email_id">Email Id</label>
                          {errors.email_id && <small className="text-danger">{errors.email_id}</small>}
                        </div>
                      </div>
                    </div>
                    {/* Occupation & Qualification */}
                    <div className="row">
                      <div className="col-md-6 col-sm-12 mb-3">
                        <div className="form-floating">
                          <select
                            className="form-select"
                            name="occupation"
                            value={formData.occupation}
                            onChange={handleChange}
                          >
                            <option value="">Select Occupation</option>
                            <option value="individual">Individual</option>
                            <option value="working">Working</option>
                            <option value="bussiness">Bussiness</option>
                          </select>
                          <label htmlFor="occupation">Occupation</label>
                          {errors.occupation && <small className="text-danger">{errors.occupation}</small>}
                        </div>
                      </div>

                      <div className="col-md-6 col-sm-12 mb-3">
                        <div className="form-floating">
                          <select
                            className="form-select"
                            name="qualification"
                            value={formData.qualification}
                            onChange={handleChange}
                          >
                            <option value="">Select Qualification</option>
                            <option value="master_degree">Master Degree</option>
                            <option value="bachelor_degree">Bachelor Degree</option>
                            <option value="diploma">Diploma</option>
                            <option value="others">Others</option>
                          </select>
                          <label htmlFor="qualification">Qualification</label>
                          {errors.qualification && <small className="text-danger">{errors.qualification}</small>}
                        </div>
                      </div>
                    </div>
                    {/* Gender & DOB */}
                    <div className="row">
                      <div className="col-md-6 col-sm-12 mb-3">
                        <div className="form-floating">
                          <select
                            className="form-select"
                            name="gender"
                            value={formData.gender}
                            onChange={handleChange}
                          >
                            <option value="">Select Gender</option>
                            <option value="male">Male</option>
                            <option value="female">Female</option>
                          </select>
                          <label htmlFor="gender">Gender</label>
                          {errors.gender && <small className="text-danger">{errors.gender}</small>}
                        </div>
                      </div>
                      <div className="col-md-6 col-sm-12 mb-3">
                        <div className="form-floating">
                          <input
                            type="date"
                            className="form-control"
                            placeholder="Date of Birth"
                            name="dob"
                            value={formData.dob}
                            onChange={handleChange}
                          // onFocus={(e) => (e.target.type = 'date')} // Change to date picker on focus
                          // onBlur={(e) => (e.target.type = 'text')} // Change back on blur
                          />
                          <label htmlFor="dob">Date of Birth</label>
                          {errors.dob && <small className="text-danger">{errors.dob}</small>}
                        </div>
                      </div>
                    </div>
                    {/* State & City */}
                    <div className="row">
                      <div className="col-md-6 col-sm-12 mb-3">
                        <div className="form-floating">
                          <select
                            className="form-select"
                            name="state"
                            value={formData.state}
                            onChange={handleChange}
                          >
                            <option value="">Select State</option>
                            {getIndianStates().map((state, index) => (
                              <option key={index} value={state}>
                                {state}
                              </option>
                            ))}
                          </select>
                          <label htmlFor="state">State</label>
                          {errors.state && <small className="text-danger">{errors.state}</small>}
                        </div>
                      </div>
                      <div className="col-md-6 col-sm-12 mb-3">
                        <div className="form-floating">
                          <select
                            className="form-select"
                            name="district"
                            value={formData.district}
                            onChange={handleChange}
                          >
                            <option value="">Select District</option>
                            {getDistricts(formData.state).map((district, index) => (
                              <option key={index} value={district}>
                                {district}
                              </option>
                            ))}
                          </select>
                          <label htmlFor="district">District</label>
                          {errors.district && <small className="text-danger">{errors.district}</small>}
                        </div>
                      </div>
                    </div>
                    {/* Submit */}
                    <div className="row">
                      <div className="col-md-6 col-sm-12">
                        <div className="mb-3">
                          <select
                            className="form-select"
                            name="opted_for"
                            value={formData.opted_for}
                            onChange={handleChange}
                            multiple
                          >
                            {/* <option value="">Select</option> */}
                            <option value="legal">Legal</option>
                            <option value="audit">Audit</option>
                            <option value="manpower">Manpower</option>
                          </select>
                          {errors.opted_for && <small className="text-danger">{errors.opted_for}</small>}
                        </div>
                      </div>
                      <div className="col-md-6 col-sm-12 mb-3">
                        <div className="form-floating">
                          <button type="submit" className="btn" style={{ backgroundColor: '#a0261d', color: 'white' }} disabled={isSubmitting}>
                            {isSubmitting ? "Submitting..." : "Submit"}
                          </button>
                        </div>
                      </div>
                    </div>
                  </form>
                </div>
              </div>
            </div>
          </div>
        </div>
      </section>
      <Footer />
    </>
  );
};

export default Optin;
